import React, { Component } from "react"
import { Link } from "gatsby"
import t from "../../../locale"

import "./Navbar.scss"

class Navbar extends Component {

  renderLinks = () => {
    let linkArr = [];
    if (typeof t === "function") {
    linkArr = [t("navLink1"), t("navLink2"), t("navLink3"), t("navLink4"), t("navLink5"), t("navLink6")]
    }

    return linkArr.map((link, i) => {
      let page;
      switch (i) {
        case 0:
          page = "/"
          break
        case 1:
          page = "/ourStory"
          break
        case 2:
          page = "/bread"
          break
        case 3:
          page = "/pastries"
          break
        case 4:
          page = "/shop"
          break
        case 5:
          page = "/contact"
          break
        default:
          page = ""
      }
      return (
        <li key={i} className="navigation-nav-li">
          <Link to={page} className="navigation-nav-link">
            {link}
          </Link>
        </li>
      )
    })
  }


  render() {
    return (
      <nav className="navigation-nav">
        {this.renderLinks()}
      </nav>
    )
  }
}


export default Navbar